<div class="card prog-card tr" *ngIf="vm && nodes.length" style="margin:10px 0;padding:15px 16px;position:relative;">
 <div [class.prog-locked-content]="vm.locked" [attr.aria-hidden]="vm.locked ? 'true' : null">
  <div class="tr-head">
    <div>
      <div class="tr-kick">{{ 'trend.kicker' | translate }}</div>
      <div class="tr-title">{{ 'trend.title' | translate }}</div>
    </div>
    <div class="tr-count">
      {{ 'trend.scanCount' | translate: { count: vm.checkCount } }}
      <span>{{ 'trend.since' | translate: { date: vm.sinceDate } }}</span>
    </div>
  </div>

  <!-- status WORD (18px) + colour dot + fixed-baseline reference chip -->
  <div class="tr-verdict" *ngIf="status">
    <span class="tr-dot" [style.background]="statusDotColor"></span>{{ statusWordKey | translate }}
    <span class="ref-chip">{{ 'trend.vsStartDated' | translate: { date: vm.sinceDate } }}</span>
  </div>

  <svg class="prog-svg tr-chart" viewBox="0 0 320 112" style="direction:ltr" preserveAspectRatio="xMidYMid meet">
    <line x1="26" [attr.y1]="baselineY" x2="294" [attr.y2]="baselineY" [style.stroke]="vm.color" stroke-width="1" stroke-dasharray="3 4" opacity="0.38" />
    <path [attr.d]="areaPath" [style.fill]="vm.color" opacity="0.07" />
    <path [attr.d]="linePath" fill="none" [style.stroke]="vm.color" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
    <ng-container *ngFor="let nd of nodes">
      <circle [attr.cx]="nd.cx" [attr.cy]="nd.cy" [attr.r]="nd.r" fill="#fff" [style.stroke]="nd.last ? statusDotColor : vm.color" [attr.stroke-width]="nd.last ? 2.5 : 2" />
      <!-- last point's value + date take the status colour (spec sec 4 mockup);
           [style.fill] not [attr.fill] so the CSS var resolves, like the circle -->
      <text [attr.x]="nd.cx" [attr.y]="nd.labelY" text-anchor="middle" font-size="11" [attr.font-weight]="nd.last ? 800 : 600" [style.fill]="nd.last ? statusDotColor : '#9a9aa5'">{{ nd.value }}</text>
      <!-- date labels INSIDE the SVG, on each point's own x (spec sec 4) -->
      <text [attr.x]="nd.cx" [attr.y]="dateY" text-anchor="middle" font-size="10" [attr.font-weight]="nd.last ? 800 : 400" [style.fill]="nd.last ? statusDotColor : '#a8a29c'">{{ nd.dateLabel }}</text>
    </ng-container>
  </svg>

  <!-- Danna 15.09: the rising line and the falling number read as a
       contradiction. Say the rule once, right under the chart. Only when the
       axis really is inverted (imprint + symptoms); on THINK, higher IS better
       and the line already moves with the number. -->
  <div class="tr-axis-note" *ngIf="vm.invert">{{ 'trend.lowerIsBetter' | translate }}</div>

  <div class="old-chips" *ngIf="vsStartMagnitude > 0">
    <span class="old-chip">{{ 'trend.vsStart' | translate }} <b>{{ vsStartWordKey | translate: { n: vsStartMagnitude } }}</b></span>
  </div>

  <div class="tr-disc">
    <b>{{ 'trend.threshold' | translate }}</b> {{ 'trend.disclaimer' | translate }}
  </div>
 </div>

  <!-- Paywall v2 lock (locked-flow spec §1): blur(5px) + overlay for unpaid.
       Only the lock ICON and the TITLE open the paywall (+ the CTA button) —
       NOT the whole graph area (Danna, handoff 0705c #4b). -->
  <div class="prog-lock-overlay" *ngIf="vm.locked">
    <div class="prog-lock-card">
      <span
        class="prog-lock-ico prog-lock-open"
        role="button"
        tabindex="0"
        [attr.aria-label]="'results.locked.graphBtn' | translate"
        (click)="openPaywall()"
        (keydown.enter)="openPaywall()"
        (keydown.space)="$event.preventDefault(); openPaywall()"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
      </span>
      <div
        class="prog-lock-title prog-lock-open"
        role="button"
        tabindex="0"
        (click)="openPaywall()"
        (keydown.enter)="openPaywall()"
        (keydown.space)="$event.preventDefault(); openPaywall()"
      >{{ 'results.locked.graphTitle' | translate }}</div>
      <div class="prog-lock-body">{{ 'results.locked.graphBody' | translate }}</div>
      <button type="button" class="prog-lock-btn" (click)="openPaywall()">{{ 'results.locked.graphBtn' | translate }}</button>
    </div>
  </div>
</div>
